export const DEPOSIT_SUCCESS = 'SEND/DEPOSIT_SUCCESS';
export const DEPOSIT_UPDATE = 'SEND/DEPOSIT_UPDATE';
export const DEPOSIT_ERROR = 'SEND/DEPOSIT_ERROR';
export const DEPOSIT_CLEAR = 'SEND/DEPOSIT_CLEAR';
export const CLAIM_FUNDS_SUCCESS = 'RECEIVE/CLAIM_FUNDS_SUCCESS';
export const CLAIM_FUNDS_ERROR = 'RECEIVE/CLAIM_FUNDS_ERROR';
export const CLEAR_CLAIM_FUNDS = 'RECEIVE/CLEAR_CLAIM_FUNDS';
export const UPDATE_CLAIMING_MODE = 'RECEIVE/UPDATE_CLAIMING_MODE';
